import { makeReactHotToast } from './makeReactHotToast.tsx';
import { MakeToast } from './types.ts';

const useToaster = () => {
  const makeToast: MakeToast = makeReactHotToast;

  return makeToast;
};

export { useToaster };
